import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  userData: {
    id: '',
    email: '',
    displayName: '',
    avatar: '',
    isActived: false,
    status: 'pending'
  },
  token: process.env.TOKEN,
  savedVacancies: {},
  recruited: {},
  recruitedCategories: [],
  recruitedCompanies: [],
  folders: []
}

const mutations = {
  [types.USER_DATA] (state, data) {
    if (data.displayName === '' || data.displayName === null) {
      if (typeof data.profile.name !== 'undefined') {
        data.displayName = data.profile.name
      }
    }
    state.userData = data
  },
  [types.USER_TOKEN] (state, data) {
    state.token = data
  },
  [types.USER_SAVED_VACANCIES] (state, data) {
    state.savedVacancies = data
  },
  [types.USER_FOLDERS] (state, data) {
    state.folders = data
  },
  [types.USER_RECRUITED] (state, data) {
    state.recruited = data
  },
  [types.USER_RECRUITED_CATEGORIES] (state, data) {
    state.recruitedCategories = data
  },
  [types.USER_RECRUITED_COMPANIES] (state, data) {
    state.recruitedCompanies = data
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/users/store.js